import request from "../http/request";

//获取用户的订单列表
export const getOrderList = () => {
  return request({
    url: "/userapp/order/list/page",
    method: "POST",
  });
};

//获取用户的订单详情
export const getOrderListDetail = (params) => {
  return request({
    url: "/userapp/order/" + params.id,
    method: "GET",
  });
};

//获取用户的退款订单详情
export const getOrderRefundDetail = (params) => {
  return request({
    url: "/userapp/order/refund/order/detail",
    method: "GET",
    params,
  });
};

//获取用户的订单详情
export const getAgreementList = (data) => {
  // platformType 应用端类型：1-微信小程序/APP，2-支付宝小程序
  const defaultParams = {
    platformType: 1,
  };

  return request({
    url: "/userapp/agreement/list",
    method: "POST",
    // data
    data: {
      ...defaultParams,
      ...data, // 用户传入的参数会覆盖默认参数
    },
  });
};

//H5下载
export const getVersionApi = (params) => {
  return request({
    url: "/userapp/client/version",
    method: "GET",
    params,
  });
};

//获取用户的个人信息
export const getInfo = () => {
  return request({
    url: "/userapp/user/personal/info",
    method: "GET",
  });
};


//用户免押订单列表分页查询
export const getListofUnsecuredOrders = (data) => {
  return request({
    url: "/userapp/order/free/deposit/page",
    method: "POST",
    data,
  });
};


//用户免押订单详情
export const getListofUnsecuredOrderDetail = (params) => {
  return request({
    url: "/userapp/order/free/deposit/detail",
    method: "GET",
    params,
  });
};


//用户免押订单详情-按钮
export const getUnsecuredOrderDetailButton = (params) => {
  return request({
    url: "/userapp/order/free/deposit/complete/apply/button",
    method: "GET",
    params,
  });
};


//用用户免押申请完结
export const requestApplicationCompletedAction = (params) => {
  return request({
    url: "/userapp/order/free/deposit/complete/apply",
    method: "GET",
    params,
  });
};


///用户免押订单扣款记录分页查询
export const getListDeductionRecord = (data) => {
  return request({
    url: "/userapp/order/free/deposit/deduct/record/page",
    method: "POST",
    data,
  });
};


///获取优惠券分页查询
export const getCouponList = (data) => {
  return request({
    url: "/userapp/discount/coupon/page",
    method: "POST",
    data,
  });
};

///获取优惠券链接
export const getCouponLinkUrl = (params) => {
  return request({
    url: "/userapp/discount/coupon/link",
    method: "GET",
    params,
  });
};


///领取优惠券
export const claimCouponAction = (params) => {
  return request({
    url: "/userapp/discount/coupon/claim",
    method: "GET",
    params,
  });
};


///根据套餐信息获取优惠券列表
export const getCouponListBySn = (data) => {
  return request({
    url: "/userapp/discount/coupon/list",
    method: "POST",
    data,
  });
};